import { createContext, useContext } from 'react';

export const PostGoodsActionContext = createContext<{ mode: 'like' | 'cart' }>({
  mode: 'like',
});

export const usePostGoodsActionMode = () => {
  const { mode } = useContext(PostGoodsActionContext);
  return mode;
};
